import React from 'react'
import { forEach } from 'lodash'
import { useStaticQuery, navigate, graphql } from 'gatsby'
import { default as FadeAnimation } from 'react-reveal/Fade'

export const parseACF = (queryData, nodeName, debug) => {
    if (queryData && queryData[nodeName]) {
        const nodes = queryData[nodeName].nodes
        const acfJSON = nodes && nodes[0].acf_json

        if (!acfJSON) return

        // Console log out if debug = true

        debug && console.log(JSON.parse(acfJSON))

        // Return parsed ACF JSON

        return JSON.parse(acfJSON)
    }
}

// Group option page keys by prefix

export const groupByPrefix = (data, prefix) => {
    let items = {}

    forEach(data, (item, key) => {
        if (key.includes(prefix)) {
            items[key.replace(`${prefix}_`, '')] = item
        }
    })

    return items
}

// Get global data

export const getGlobalData = (prefix) => {
    const query = graphql`
        query {
            allWordpressGlobal {
                nodes {
                    acf_json
                }
            }
        }
    `

    // Fetch global data

    const globalData = parseACF(useStaticQuery(query), 'allWordpressGlobal')

    // Return global + grouped by prefix

    return {
        global: globalData,
        data: groupByPrefix(globalData, prefix)
    }
}

// Fade Animation

export const Fade = ({ children, ...restProps }) => {
    return (
        <FadeAnimation bottom distance={'40px'} {...restProps}>
            {children}
        </FadeAnimation>
    )
}

// Render Link

export const renderLink = (link, i) => {
    if (link.type === 'internal') {
        return (
            <div
                className="link"
                key={i}
                onClick={e => {
                    e.preventDefault()
                    navigate(`${link.url}`)
                }}
            >
                {link.title}
            </div>
        )
    } else {
        return (
            <a className="link" key={i} href={`${link.url}`} target={`_blank`}>
                {link.title}
            </a>
        )
    }
}
